export const capitalize = (text) => {
  text = text.toLowerCase().split(' ');
  let capitalizedText = '';
  text.map((e) => {
    capitalizedText =
      capitalizedText + ' ' + (e.charAt(0).toUpperCase() + e.slice(1));
  });
  return capitalizedText;
};
